var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 23.4749C9.9375 25.8359 8.0475 27.7499 5.7195 27.7499C3.3885 27.7499 1.5 25.8359 1.5 23.4749C1.5 21.1154 3.39 19.2014 5.7195 19.2014C8.049 19.2014 9.9375 21.1139 9.9375 23.4749ZM9.9375 23.4749V5.19295C9.9375 4.41295 10.5285 3.76195 11.301 3.69145L26.8635 2.25745C27.0718 2.23841 27.2817 2.26314 27.4799 2.33005C27.678 2.39695 27.86 2.50456 28.0141 2.64595C28.1682 2.78735 28.2911 2.9594 28.3747 3.15108C28.4584 3.34275 28.5011 3.54981 28.5 3.75895V21.7649M28.5 21.7649C28.5 24.1244 26.61 26.0399 24.282 26.0399C21.951 26.0399 20.0625 24.1244 20.0625 21.7649C20.0625 19.4054 21.9525 17.4899 24.282 17.4899C26.6115 17.4899 28.5 19.4039 28.5 21.7649Z",
    stroke: "#25A249",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.9598b2145a6e2151a4f3cb8b0eceadc9.svg";
export { ForwardRef as ReactComponent };